import { IconChevronDown } from "./Icons";
import { CaseRow } from "./CaseRow";
import { CategoryConfig, Case } from "../../types/home";

// ============================================
// CATEGORY PANEL — Soft headers
// ============================================
// Category headers reduced to subtle text labels.
// Case names are the loudest visual element.

export interface CaseCategorySectionProps {
  config: CategoryConfig;
  cases: Case[];
  isExpanded: boolean;
  onToggle: () => void;
  onDeleteCase: (e: React.MouseEvent, caseItem: Case) => void;
  onStarCase?: (caseId: string, starred: boolean) => void;
}

export function CaseCategorySection({
  config,
  cases,
  isExpanded,
  onToggle,
  onDeleteCase,
  onStarCase,
}: CaseCategorySectionProps) {
  if (cases.length === 0) return null;

  return (
    <div>
      {/* Header — soft text label, no colored icon */}
      <button
        onClick={onToggle}
        className="w-full flex items-center gap-2 px-1 py-1.5 group"
      >
        <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider group-hover:text-slate-500 transition-colors">
          {config.label}
        </span>
        <span className="text-[10px] text-slate-300">{cases.length}</span>
        <div className="flex-1" />
        <IconChevronDown
          className={`w-3.5 h-3.5 text-slate-300 group-hover:text-slate-400 transition-all duration-200 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Expandable content */}
      <div
        className={`transition-all duration-200 ease-in-out overflow-hidden ${
          isExpanded ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="space-y-1">
          {cases.map((c) => (
            <div
              key={c.id}
              className="bg-white rounded-lg border border-slate-100 hover:border-slate-200 transition-colors"
            >
              <CaseRow
                caseData={c}
                onDelete={(e) => onDeleteCase(e, c)}
                onStar={onStarCase}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
